// Smooth-scrolls to an element by id and re-corrects once layout settles.
export function scrollToAnchor(id: string, offset = 90) {
  const go = (behavior: ScrollBehavior = "smooth") => {
    const el = document.getElementById(id);
    if (!el) return false;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior });
    return true;
  };

  go();

}
